import { Edit, ExpandMore } from '@mui/icons-material'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  CircularProgress,
  IconButton, Tooltip,
  Typography
} from '@mui/material'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import { ERROR_COLORS, GRAY_COLORS, INFO_COLORS } from 'asterX-UI'
import { BlueLines } from 'asterX-UI/Icons/BlueLines'
import { DeleteIcon } from 'asterX-UI/Icons/DeleteIcon'
import { DownloadIcon } from 'asterX-UI/Icons/DownloadIcon'
import { FileIcon } from 'asterX-UI/Icons/FileIcon'
import { NotFound } from 'components/NotFound/NotFound'
import { useAuthStore } from 'context/AuthStore'
import { useContractStore } from 'context/ContractStore'
import { CreditFlow } from 'lib/api/services/creditFlow.service'
import { getValidDate } from 'lib/utils'
import { enqueueSnackbar } from 'notistack'
import React, { lazy, startTransition, Suspense, useState } from 'react'
import QrIcon from '../../asterX-UI/Icons/QR_Icon'
import ActionModal from '../../asterX-UI/Modals/ActionModal'

const UserRevertModal = lazy(() => import('components/RoleModals/UserRevertModal/UserRevertModal'))

export const FileAccordion = ({
  data = [],
  open = true,
  title,
  defaultStyles = true,
  guaranteeDocs = false,
  isEdit = null,
  readonly = false,
  updateGuaranteeDocs = () => {}
}) => {
  const { authStore } = useAuthStore()
  const {
    contractStore: { loanApplicationData },
    contractStoreFunc: { setLoanApplicationData, setManagerWorking }
  } = useContractStore()

  const [expanded, setExpanded] = useState(open)

  const [openEdit, setOpenEdit] = useState(null)

  const [confirmDlg, setConfirmDlg] = useState({ open: false, fileId: null, category: '', name: '' })
  const [deleting, setDeleting] = useState(false)
  const openDeleteConfirm = (id, name,catergory) => {
    setConfirmDlg({ open: true, fileId: id, category: catergory , name: name || '' })
  }

  const closeDeleteConfirm = () => {
    if (deleting) return
    setConfirmDlg({ open: false, fileId: null, category: '' , name: '' })
  }



  const openEditModal = (e, isEdit) => {
    e.stopPropagation()
    setManagerWorking(true)
    startTransition(() => {
      setOpenEdit(isEdit)
    })
  }

  const closeEditModal = () => {
    setManagerWorking(false)
    setOpenEdit(null)
  }

  const handleChange = () => {
    setExpanded(prevExpanded => !prevExpanded)
  }

  const openFile = link => {
    window.open(link, '_blank')
  }

  const deleteFile = async id => {
    if (!id) {
      enqueueSnackbar(`Нет данных для обработки!`, { variant: 'info' })
      return
    }
    const res = await CreditFlow.deleteFile(id)
    if (!res?.data) {
      enqueueSnackbar(`${res?.status}`, { variant: 'error' })
      return
    }
    const response = await CreditFlow.getApplicationById(loanApplicationData?.id)
    if (!guaranteeDocs) {
      setLoanApplicationData(response.data)
    } else {
      const updatedCollateralFiles = response?.data?.collateralFiles || []
      updateGuaranteeDocs(updatedCollateralFiles)
    }
  }

  const handleConfirmDelete = async () => {
    if (!confirmDlg.fileId) return
    try {
      setDeleting(true)
      await deleteFile(confirmDlg.fileId)
      closeDeleteConfirm()
    } finally {
      setDeleting(false)
    }
  }

  const defaultSx = defaultStyles
    ? {
        border: `1px solid ${GRAY_COLORS[200]}`,
        padding: expanded ? '20px' : '0 20px 0 20px'
      }
    : {}

  // const redirectToSignDocs = () => {
  //   const form = document.createElement('form')
  //   form.method = 'GET'
  //   form.action = '/sign-docs'
  //   document.body.appendChild(form)
  //   form.submit()
  // }

  return (
    <>
      <Suspense
        fallback={
          <Box display="flex" justifyContent="center" alignItems="center">
            <CircularProgress />
          </Box>
        }
      >
        {openEdit && !readonly && <UserRevertModal openModal={openEdit} closeModal={closeEditModal} />}
      </Suspense>

      <Accordion expanded={expanded} onChange={handleChange} sx={{ ...defaultSx }}>
        <AccordionSummary expandIcon={<ExpandMore />} aria-controls="panel1a-content" id="panel1a-header">
          <Typography variant="subtitle1">{title}</Typography>
          {!readonly && isEdit && loanApplicationData?.status?.code === 'userRevert' && (
            <IconButton
              sx={{
                padding: 1,
                margin: 0,
                marginLeft: 'auto',
                '&:hover': {
                  backgroundColor: INFO_COLORS[400]
                },
                backgroundColor: GRAY_COLORS[200]
              }}
              onClick={e => openEditModal(e, isEdit)}
            >
              <Edit />
            </IconButton>
          )}
        </AccordionSummary>

        <AccordionDetails>
          {data?.length > 0 ? (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                width: '100%'
              }}
            >
              {data?.map(item => (
                <Box
                  key={`key-${item?.id}`}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                    width: '100%'
                  }}
                >
                  <Box
                    sx={{
                      fontSize: 14,
                      fontWeight: 600,
                      wordBreak: 'break-word',
                      display: 'flex',
                      gap:'10px',
                      alignItems: 'center'
                    }}
                  >
                    {item?.category?.name}
                    {item?.category?.name.includes('(QR)') && (
                      <Tooltip
                        title="Документ подписан онлайн"
                        arrow
                        componentsProps={{
                          tooltip: {
                            sx: { fontSize: 12, fontWeight: 400 }
                          }
                        }}
                      >
                        <span style={{display:'flex',alignItems:'center', cursor: 'default'}}>
                          <QrIcon
                           size={16}
                            style={{ color: '#40b758',cursor: 'default' }}
                            onClick={() => {}}
                          />
                        </span>
                      </Tooltip>
                    )}
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      p: 3,
                      borderRadius: '8px',
                      border: `1px solid ${GRAY_COLORS[200]}`
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                      <Box sx={{ position: 'relative' }}>
                        <FileIcon />
                        <Box
                          sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)'
                          }}
                        >
                          <BlueLines />
                        </Box>
                      </Box>

                      <Box>
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: 14,
                            fontWeight: 500,
                            wordBreak: 'break-word'
                          }}
                        >
                          {item?.originalName}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: 12,
                            fontWeight: 400,
                            color: GRAY_COLORS[600]
                          }}
                        >
                          {getValidDate(item?.createdDate, true)}
                        </Typography>
                      </Box>
                    </Box>

                    <Box sx={{ display: 'flex', gap: 1 }}>
                      <IconButton sx={{ p: 1 }} onClick={() => openFile(item?.url)}>
                        <DownloadIcon sx={{ color: GRAY_COLORS[600] }} />
                      </IconButton>
                      {[
                        'userUploadBankDocs',
                        'userUploadCollateralDocs',
                        'userCreateLoanApplication',
                        'userRevert'
                      ].includes(item?.category?.step) &&
                        authStore.isUserRole === 'MANAGER' &&
                        item?.category?.step !== 'wings' && loanApplicationData?.status?.code!=='serviceComplete' && (
                          <IconButton sx={{ p: 1 }} onClick={() =>
                            openDeleteConfirm(item?.id, item?.originalName, item?.category?.name)}>
                            <DeleteIcon sx={{ color: GRAY_COLORS[600] }} />
                          </IconButton>
                        )}
                    </Box>
                  </Box>
                </Box>
              ))}
            </Box>
          ) : (
            <NotFound />
          )}
        </AccordionDetails>
      </Accordion>

      <ActionModal
        open={confirmDlg.open}
        onClose={closeDeleteConfirm}
        onCancel={closeDeleteConfirm}
        onConfirm={handleConfirmDelete}
        title={(<Box
        sx={{
          width: 30,
          height: 30,
          borderRadius: '50%',
          border: '3px solid #ff2f6d',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 2,
          order:-1
        }}
      >
        <CloseRoundedIcon sx={{ fontSize: 20, color: '#ff2f6d' }} />
      </Box>)}
        labelCancel="Отмена"
        labelConfirm={deleting ? 'Удаляю…' : 'Удалить'}
        color="secondary"
        cancelBtnColor={'error'}
        maxWidth="xs"
        disableConfirm={deleting}
      >
        <Box>
          <Typography sx={{ fontSize: '18px', fontWeight: 600 }}>Удаление файла</Typography>
        </Box>
        <Typography
          variant="body2"
          lang="ru"
          sx={{
            color: GRAY_COLORS[700],
            width: '100%',
            whiteSpace: 'normal',
            wordBreak: 'normal',
            overflowWrap: 'break-word',
            hyphens: 'auto',
            WebkitHyphens: 'auto',
            msHyphens: 'auto'
          }}
        >
          {confirmDlg.name ? (
            <>
              Действительно удалить файл в категории <b>«{confirmDlg.category}»</b> с названием «{confirmDlg.name}»?
              <br />
              <b style={{ color: (ERROR_COLORS && ERROR_COLORS[600]) || '#d32f2f' }}>
                Это действие необратимо.
              </b>
            </>
          ) : (
            'Действительно удалить выбранный файл? Это действие необратимо.'
          )}
        </Typography>
      </ActionModal>
    </>
  )
}
